import FlexBox from 'components/Shared/Container/FlexBox';
import Icon from 'components/Shared/Icon/Icon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
const SummaryChipContainer = styled(FlexBox) `
  margin-right: 16px 0;
  padding: 8px;
  width: fit-content;
  border-radius: 8px;
  color: ${({ theme }) => theme.palette.grey.A800};
  background: ${({ theme }) => theme.backgrounds.light};
  font-family: Lato;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
`;
const SummaryChip = ({ summary: { farmCount, countryCount, originCount }, }) => {
    const { t } = useTranslation();
    if (!countryCount && !originCount && !farmCount && farmCount < 2) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(SummaryChipContainer, { gap: 2 },
        countryCount ? (React.createElement(FlexBox, { gap: 1 },
            React.createElement(Icon, { name: "nation-flag" }),
            countryCount,
            " ",
            countryCount === 1 ? t('country') : t('countries'))) : undefined,
        originCount ? (React.createElement(FlexBox, { gap: 1 },
            React.createElement(Icon, { name: "pin" }),
            originCount,
            " ",
            originCount === 1 ? t('origin') : t('origins'))) : undefined,
        farmCount && farmCount > 1 ? (React.createElement(FlexBox, { gap: 1 },
            React.createElement(Icon, { name: "farm" }),
            farmCount,
            " ",
            t('farms'))) : undefined));
};
export default SummaryChip;
